class GdprBanner extends HTMLElement {
  constructor() {
    super();
    this.confirmButton = this.querySelector(".gdpr-banner__confirm-button");
    this.GDPRBanner = this.querySelector(".gdpr-banner");

    this.COOKIE_POLICY_NAME = "eg_cookieconsent_status";

    if (!this.GDPRBanner) {
      return;
    }

    this.initCookieBanner();
    this.registerEventListener();
  }

  hideBanner() {
    this.GDPRBanner.style.display = "none";
  }

  showBanner() {
    this.GDPRBanner.style.display = "block";
  }

  updateShopifyConsent() {
    try {
      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1",
          },
        ],
        (error) => {
          if (!error) {
            window.Shopify.customerPrivacy.setTrackingConsent(
              {
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: false,
              },
              () => {}
            );
          }
        }
      );
    } catch (e) {
      // swallow
    }
  }
  handleAccept(e) {
    setCookie(this.COOKIE_POLICY_NAME, "dismiss", 365);
    this.hideBanner();
    this.updateShopifyConsent();
  }

  registerEventListener() {
    if (this.confirmButton) {
      this.confirmButton.addEventListener("click", (e) => {
        this.handleAccept(e);
      });
    }
  }

  initCookieBanner() {
    if (getCookie(this.COOKIE_POLICY_NAME) !== "dismiss") {
      this.showBanner();
    }
  }
}
customElements.define("gdpr-banner", GdprBanner);
